import type { AdminProductScope } from './product-scope';

export type AdminProductVariant = 'all' | 'app' | 'studio';

const configuredProduct = import.meta.env.VITE_ADMIN_PRODUCT?.trim().toLowerCase();

export const ADMIN_PRODUCT: AdminProductVariant =
  configuredProduct === 'app' || configuredProduct === 'studio' || configuredProduct === 'all'
    ? configuredProduct
    : 'all';

export const ADMIN_PRODUCT_SCOPE: AdminProductScope | null =
  ADMIN_PRODUCT === 'app' || ADMIN_PRODUCT === 'studio' ? ADMIN_PRODUCT : null;

export function isProductScopeEnabled(scope: AdminProductScope): boolean {
  return ADMIN_PRODUCT === 'all' || ADMIN_PRODUCT === scope;
}

export function productHomePath(): string {
  return ADMIN_PRODUCT_SCOPE ? `/${ADMIN_PRODUCT_SCOPE}` : '/platform';
}
